import { Component } from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { environment } from './../environments/environment'
import { strings } from '../../assets/languageStrings';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  public selectedLanguage: any;
  languageData: any;
  public lang: any = {};
  currentYear = new Date().getFullYear();
  constructor(private http:HttpClient) { }

  ngOnInit(): void {
this.getLanguageTokens()

  }

  // public getLanguageTokens(){
  //   let body= {
  //     "project":"SignupForm",
  //     "url":"Footer"
  //   }
  //   this.http
  //   .post(environment.app.langApi + 'string/project-url-strings',body, {
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   })
  //   .subscribe(
  //     (response: any) => {
  //       // console.log(response)
  //       this.lang = {};
  //       // this.languageData = response.strings
  //       this.selectedLanguage = sessionStorage.getItem("language")
  //       for (let token of response.strings) {
  //         this.lang[token.key] = token[this.selectedLanguage];
  //       }

  //       console.log(this.lang)

  //     })
  // }

  public getLanguageTokens(){
    let body= {
      "project":"SignupForm",
      "url":"Footer"
    }
    this.http
    .post(environment.app.langApi + 'string/project-url-strings',body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .subscribe(
      (response: any) => {
        if (!response || !response.strings || response.strings.length === 0) {
          // fallback to local language strings
          this.loadLocalLanguageStrings();
        } else {
          this.setupLanguage(response.strings);
        }
      },
      (error) => {
        // on error, also fallback to local strings
        this.loadLocalLanguageStrings();
      }
    )
  }

  private loadLocalLanguageStrings() {
    this.setupLanguage(strings);
  }

  private setupLanguage(strings: any[]) {
    this.lang = {};
    this.languageData = strings;
    this.selectedLanguage = sessionStorage.getItem("language");

    for (let token of strings) {
      this.lang[token.key] = token[this.selectedLanguage];
    }
  }
}


